import {
    ADD_MEDICINE_TO_LIST,
    PUSH_MED_AT_INDEX_OF,
    EDIT_EPRESCRIPTION,
    DELETE_MEDICINE_FROM_LIST,
    AUTH_LOGIN,
    AUTH_LOGOUT,
    ADD_PATIENT_DETAILS,
    RESET_ORDER_DETAIL,
    MENU_CHANGE,
    TOGGLE_MENU,
    SET_PARTNERS,
    UPDATE_PPRESCRIPTION,
    ADD_PPRESCRIPTION_URL,
    DELETE_PRESCRIPTION_URL_AT_POSITION,
    SET_SPECIALITIES,
    ADD_AILMENT,
    DELETE_AILMENT,
    TOGGLE_FILTER,
    SET_CAREFILL_PRESCRIPTIONS,
    ADD_CAREFILL_PRESCRIPTIONS,
    DELETE_CAREFILL_PRESCRIPTION,

    EDIT_NONRXMEDICINES,
    ADD_NONRXMEDICINE_TO_LIST,
    PUSH_NONRXMED_AT_INDEX_OF,
    DELETE_NONRXMEDICINE_FROM_LIST,
} from '../ActionTypes/ActionTypes';

const initialState = {
    menu: '/allOrders',
    collapsed: false,
    filter: true,
    order_id: '',
    user_id: '',
    doctor_id: '',
    p_prescriptions_url: [],
    start_date: '',
    end_date: '',
    specialities: [],
    ailments: [],
    ep_id: '',
    medicineList: [],
    token: '',
    loggedIn: false,
    partners_list: [],
    carefill_prescriptions: [],

    nonRxMedicineList: [],
};

const AppReducer = (state = initialState, action) => {
    switch (action.type) {
    case MENU_CHANGE:
        return {
            ...state,
            menu: action.key,
        };

    case TOGGLE_MENU:
        return {
            ...state,
            collapsed: !state.collapsed,
        };

    case TOGGLE_FILTER:
        return {
            ...state,
            filter: !state.filter,
        };

    case ADD_MEDICINE_TO_LIST:
        return {
            ...state,
            medicineList: state.medicineList.concat(action.medicine),
        };

    case EDIT_EPRESCRIPTION:
        return {
            ...state,
            medicineList: action.payload.list,
            ep_id: action.payload.ep_id,
        };

    case PUSH_MED_AT_INDEX_OF:
        state.medicineList.splice(action.payload.id, 1, action.payload.data);
        return {
            ...state,
        };

    case UPDATE_PPRESCRIPTION:
        state.p_prescriptions_url.splice(action.payload.id, 1, action.payload.data);
        return {
            ...state,
        };

    case DELETE_MEDICINE_FROM_LIST:
        const updatedList = state.medicineList.filter((data, index) => index !== action.id);
        return {
            ...state,
            medicineList: updatedList,
        };

    case EDIT_NONRXMEDICINES:
        console.log('running here...');
        console.log(state.nonRxMedicineList);
        return {
            ...state,
            nonRxMedicineList: action.payload.list,
            ep_id: action.payload.ep_id,
        };

    case ADD_NONRXMEDICINE_TO_LIST:
        return {
            ...state,
            nonRxMedicineList: state.nonRxMedicineList.concat(action.medicine),
        };

    case PUSH_NONRXMED_AT_INDEX_OF:
        state.nonRxMedicineList.splice(action.payload.id, 1, action.payload.data);
        return {
            ...state,
        };

    case DELETE_NONRXMEDICINE_FROM_LIST:
        console.log('I am here', action.id);
        const updatedNonRxList = state.nonRxMedicineList.filter((data, index) => index !== action.id);
        return {
            ...state,
            nonRxMedicineList: updatedNonRxList,
        };


    case AUTH_LOGIN:
        return {
            ...state,
            token: action.token,
            loggedIn: true,
        };

    case AUTH_LOGOUT:
        return {
            ...state,
            token: '',
            loggedIn: false,
            menu: '/allOrders',
        };

    case ADD_PATIENT_DETAILS:
        const value = action.data;

        return {
            ...state,
            medicineList: [],
            ailments: value.ailments,
            order_id: value.order_id,
            user_id: value.user_id,
            doctor_id: value.doctor_id,
            p_prescriptions_url: value.p_prescriptions_url,
            start_date: value.start_date,
            end_date: value.end_date,
        };

    case RESET_ORDER_DETAIL:
        return {
            ...state,
            order_id: '',
            user_id: '',
            ailments: [],
            doctor_id: '',
            p_prescriptions_url: [],
            start_date: '',
            end_date: '',
            medicineList: [],
        };

    case ADD_PPRESCRIPTION_URL:
        return {
            ...state,
            p_prescriptions_url: state.p_prescriptions_url.concat(action.url),
        };

    case DELETE_PRESCRIPTION_URL_AT_POSITION:
        const updatedPPrescriptionList = state.p_prescriptions_url.filter((url, index) => index !== action.id);
        return {
            ...state,
            p_prescriptions_url: updatedPPrescriptionList,
        };

    case SET_PARTNERS:
        console.log(action);
        return {
            ...state,
            partners_list: action.payload.partners,
        };

    case SET_SPECIALITIES:
        return {
            ...state,
            specialities: action.payload.sps,
        };

    case ADD_AILMENT:
        const updatedAils = [...state.ailments, action.payload.ail];
        return {
            ...state,
            ailments: updatedAils,
        };

    case DELETE_AILMENT:
        const updatedDeleteAils = state.ailments.filter(ail => ail.id !== action.payload.id);
        return {
            ...state,
            ailments: updatedDeleteAils,
        };

    case SET_CAREFILL_PRESCRIPTIONS:
        return {
            ...state,
            carefill_prescriptions: action.payload.carefill_prescriptions,
        };

    case ADD_CAREFILL_PRESCRIPTIONS:
        console.log(action);
        return {
            ...state,
            carefill_prescriptions: state.carefill_prescriptions.concat(action.payload.linkedPrescriptions),
        };

    case DELETE_CAREFILL_PRESCRIPTION:
        const updatedPrescription = state.carefill_prescriptions.filter(cp => cp.id !== action.payload.idToDelete);
        return {
            ...state,
            carefill_prescriptions: updatedPrescription,
        };

    default:
        return state;
    }
};


export default AppReducer;



// WEBPACK FOOTER //
// ./src/Reducer/AppReducer.js